import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['type']

  connect() {
    // converts select2 events into native events
    $('#integration_type').on('select2:select', function () {
      let event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    });

    this.selectType()
  }

  selectType() {
    let integrationId = $(this.typeTarget).data('integrationId')
    let integrationType = $(this.typeTarget).find('option:selected').text();
    let communityId = $(this.typeTarget).data('communityId')
    let integrationInfo = document.getElementById('integration-info')

    $.get({
      url: `/admin/communities/${communityId}/integrations/get_form_inputs`,
      data: {
        id: integrationId,
        integration: integrationType
      },
      success: (results) => {
        $(integrationInfo).replaceWith(results)

        if(integrationType === 'BlueMoon') {
          $('.applicants-container, .scheduling-container').hide()
        } else {
          $('.applicants-container, .scheduling-container').show()
        }
      }
    })
  }
}